<template>
<div class="workbench">
  <div class="workbench-title flex align-center">
    <i class="iconfont icongongzuotai"></i>
    <span class="size14 area-tit">工作台</span>
  </div>
  <div class="workbench-box flex" style="margin-bottom: 12px;">
      <div v-for="item in itemList.filter((i,index)=>index<6)"
           :key="item.id"
           class="flex align-center workbench-item-box"
           @click="goPage(item.path)">

        <div class="flex align-center justify-center workbench-item-icon" :style="{color:showStoreMask?item.iconColor:'#666'}">
          <i class="iconfont" :class="item.icon"></i>
        </div>

        <div class="workbench-item-info">
          <div class="info-str1">&nbsp;</div>
          <div class="info-str size13 flex align-center">
            {{item.name}}
            <gj-badge v-if="item.num" style="margin-left: 4px;" :value="item.num>99?'99+':item.num"></gj-badge>
          </div>
          <div class="info-str1 size12" :style="{color:item.tipColor}">
            <template v-if="item.tips">
              {{item.tipL}}{{item.tips}}{{item.tipR}}
            </template>
            <template v-else>&nbsp;</template>
          </div>
        </div>

      </div>
  </div>

  <div class="workbench-box flex">
      <div v-for="item in itemList.filter((i,index)=>index>5)"
          :key="item.id"
          class="flex align-center workbench-item-box"
          @click="goPage(item.path)">

        <div class="flex align-center justify-center workbench-item-icon" :style="{color:showStoreMask?item.iconColor:'#666'}">
          <i class="iconfont" :class="item.icon"></i>
        </div>

        <div class="workbench-item-info">
          <div class="info-str1">&nbsp;</div>
          <div class="info-str size13 flex align-center">
            {{item.name}}
            <gj-badge v-if="item.num" style="margin-left: 4px;" :value="item.num>99?'99+':item.num"></gj-badge>
          </div>
          <div class="info-str1 size12" :style="{color:item.tipColor}">
            <template v-if="item.tips">
              {{item.tipL}}{{item.tips}}{{item.tipR}}
            </template>
            <template v-else>&nbsp;</template>
          </div>
        </div>

      </div>
  </div>

</div>
</template>

<script>
import {getWorkbench} from "@/api/dashboard";
import {option} from "@/views/modules/home/dashboard/components/workbench/options";
import {mapGetters} from "vuex";
import {dashboardMixin, queryMixin} from "@/minxins";

export default {
  name: "app-workbench",
  mixins: [queryMixin, dashboardMixin],
  data(){
    return{
      itemList:[]
    }
  },
  created() {
    this.itemList = this._.cloneDeep(option)
  },
  activated() {
    this.$gjQuery()
  },
  methods:{
    goPage(path){
      if(path == '/sale/review') {
        const time = new Date().getTime()
        path += `?timeStamp=${time}`
      }
      this.$router.push(path)
    },
    $gjQuery(){
      if(!this.showStoreMask){
        return
      }
      getWorkbench().then(res=>{
        this.itemList.forEach(line=>{
          let item = res.find(r=>r.entrance===line.id);
          if(item){
            this.$set(line,'num',item.num);
            this.$set(line,'tips',item.tips);
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.workbench{
  box-sizing: border-box;
  height: 238px;
  padding: 0 16px 18px;
  border: 4px;
  background-color: #fff;
  .workbench-title{
    height: 40px;
  }
  .workbench-box{
    flex-wrap:wrap;
  }

  .workbench-item-box{
    background-color: #F6F8FB;
    box-sizing: border-box;
    padding-left: 4px;
    cursor:pointer;
    height: 72px;
    border-radius: 4px;
    flex: 1;
  }
  .workbench-item-box+.workbench-item-box{
    margin-left: 10px;
  }
  .workbench-item-box:hover{
    background-color: #EEF3FB
  }
  .workbench-item-icon{
    flex:none;
    height: 42px;
    width: 38px;
    border-radius: 4px;
    .iconfont{
      font-size: 18px;
    }
  }
  .workbench-item-info{
    //padding-left: 12px;
    .info-str1{
      line-height: 18px;
      height: 18px;
    }
    .info-str{
      font-weight: 600;
      line-height: 18px
    }
  }
}
/deep/.el-badge{
  vertical-align: unset;
  .el-badge__content{
    padding: 0 4px;
    color: #F5222D;
    background: #FFF1F0;
    border-radius: 7.5px;
  }
}
</style>